import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React, { FC, ReactNode, useState } from 'react';
import { MainTableHeadStyle, ThreeLevelHeadStyle, ThreeLevelIconStyle, ThreeLevelSubTableStyle, ThreeLevelTableCellStyle } from './styled';

interface CollapsibleTableContainerProps {
  isThreeLevel: boolean,
  children: ReactNode,
  title?: string,
  openByDefault?: boolean,
  displayHeaderOnly?: boolean,
  size?: "custom" | "medium" | "small";
}

export const CollapsibleTableContainer: FC<CollapsibleTableContainerProps> = ({
  isThreeLevel,
  children,
  title,
  openByDefault,
  displayHeaderOnly,
  size = "medium"
}) => {
  const [open, setOpen] = useState(openByDefault ?? false);
  // a row that displays only the header
  if (displayHeaderOnly) {
    return (
      <TableRow className='threeLevel' sx={MainTableHeadStyle}>
        <TableCell sx={ThreeLevelTableCellStyle}>
          <Typography sx={ThreeLevelHeadStyle} gutterBottom component="div">
            {title}
          </Typography>
        </TableCell>
      </TableRow>
    )
  }
  return (
    <>
      {
        isThreeLevel ? <TableRow onClick={() => setOpen(!open)} className='threeLevel' sx={MainTableHeadStyle}>
          <TableCell sx={ThreeLevelTableCellStyle}>
            {open ? <ArrowDropUpIcon sx={ThreeLevelIconStyle} /> : <ArrowDropDownIcon sx={ThreeLevelIconStyle} />}
            <Typography onClick={() => setOpen(!open)} sx={ThreeLevelHeadStyle} gutterBottom component="div">
              {title}
            </Typography>
            {open && <Table
              size={size}
              sx={ThreeLevelSubTableStyle}
              onClick={(e: React.MouseEvent) => e.stopPropagation()}
            >
              {children}
            </Table>}
          </TableCell>
        </TableRow> : <>{children}</>
      }
    </>
  )
}